import { SeatAvailabilityStatus } from '@vista-digital/ocapi-types/v1';
import { getSeatAvailabilityPreviewForShowtime } from './get-seat-availability-preview-for-showtime';
/**
 * Returns a summary of the showtime seat availability preview for the given showtime.
 */
export const getSeatAvailabilityPreviewSummaryForShowtime = (showtimeId) => {
    const showtimeSeatAvailability = getSeatAvailabilityPreviewForShowtime(showtimeId);
    if (!showtimeSeatAvailability) {
        return;
    }
    const summary = showtimeSeatAvailability.seatAvailabilities.reduce((acc, seatAvailability) => {
        acc.totalSeats++;
        if (seatAvailability.status === SeatAvailabilityStatus.Available) {
            acc.availableSeats++;
        }
        return acc;
    }, { totalSeats: 0, availableSeats: 0, isSoldOut: false });
    summary.isSoldOut = showtimeSeatAvailability.isSoldOut;
    return summary;
};
//# sourceMappingURL=get-seat-availability-preview-summary-for-showtime.js.map